<template>
  <div class="import-participantes-list">
    <app-search-bar/>
    
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Imports">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="importsParticipantes" 
                :fields="fields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaRegistro)="data">
                {{ data.item.fechaRegistro | fechaHora }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown 
                    variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item 
                      @click.stop="importarItem(data.item)">
                    <i class="fa fa-check"></i>Agregar Participantes</b-dropdown-item>

                  <b-dropdown-item 
                      @click.stop="borrarItem(data.item)">
                    <i class="fa fa-remove"></i>Borrar Import</b-dropdown-item>
                </b-dropdown>
              </template>            
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item 
              @click.stop="importarXls">
            <i class="fa fa-plus"></i>Importar Listado</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="importacionModal" 
        title="Importar Participantes"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importacion
        :eventoId="parseInt(eventoId)"
        @close="closeImportacion">
      </app-importacion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Importacion from '../participantes/Importacion.vue'
import SearchBar from  '../searchList/SearchBar.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importsParticipantes/getField',
  mutationType: 'importsParticipantes/updateField',
});

export default {
  name: 'ImportParticipantesList',
  components: {
    appImportacion: Importacion,
    appSearchBar: SearchBar,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      eventoId: 0,

      fields: [
        { key: 'fechaRegistro' },
        { key: 'usuario' },
        { 
          key: 'cantidadParticipantes',
          label: 'Cant.Participantes',
          class: 'text-right'
        },
        { 
          key: 'cantidadParticipantesInvalidos',
          label: 'Cant.Invalidos',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      // 'evento',
      'importsParticipantes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',

      'resultadoImportacion'
    ]),
  },
  created() {
    this.eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    // if ((/true/i).test(this.$store.getters['user/admin'])) {
    //   this.editarHabilitado = true;
    //   this.borrarHabilitado = true;
    // }

    this.getItems();
  },  
  methods: {
    getItems() {
      this.showSpinner();
      this.$store.dispatch('importsParticipantes/inicializar', this.eventoId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    consultar (item) {
      this.$router.push({ name: 'ImportParticipantes', 
                          params: { 
                            eventoId: this.eventoId,
                            id: item.id
                          }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar el import de participantes?', 
            this.borrarImportParticipantes.bind(this, item.id), 'Si', null, 'No')
    },
    borrarImportParticipantes (importParticipantesId) {
      let params = {
        eventoId: this.eventoId,
        importParticipantesId
      }

      this.showSpinner();
      this.$store.dispatch('importsParticipantes/delete', params)
        .then(() => {
          this.showModalMsj('El import seleccionado se borró con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    importarItem (item) {
      this.showModalConfirm('¿Desea agregar los participantes del import seleccionado al evento?', 
            this.importarParticipantes.bind(this, item.id), 'Si', null, 'No')
    },
    importarParticipantes (importParticipantesId) {
      let params = {
        eventoId: this.eventoId,
        importParticipantesId
      }

      this.showSpinner();
      this.$store.dispatch('importsParticipantes/importar', params)
        .then(() => {
          if (this.resultadoImportacion == 0) {
            this.showModalMsj('No se agregaron nuevos participantes al evento.', null, null, 'light')
          } else if (this.resultadoImportacion == 1) {
            this.showModalMsj(`Se agregó un nuevo participante al evento.`, null, null, 'light')
          } else {
            this.showModalMsj(`Se agregaron ${this.resultadoImportacion} nuevos participantes al evento.`, null, null, 'light')
          }
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    goBack() {
      // this.$router.push({ name: 'Eventos' });
      this.$router.go(-1);
    },
    importarXls() {
      this.$refs.importacionModal.show();
    },
    closeImportacion(params) {
      this.$refs.importacionModal.hide();
      if ((/true/i).test(params.actualizado)) {
        if (params.participantesImportados == 0) {
          this.showErrorMsj(new Error(`No se importaron participantes del listado.`));
        } else {
          this.getItems();

          // this.$router.push({ name: 'ImportParticipantes', 
          //                 params: { 
          //                   eventoId: this.eventoId,
          //                   id: params.importParticipantesId
          //                 }});
        }
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },
  }    
}
</script>

<style>
  .import-participantes-list .registro table td[aria-colindex="1"] {
    width: 15%;
  }
  .import-participantes-list .registro table td[aria-colindex="2"] {
    width: calc(55% - 30px);
  }
  .import-participantes-list .registro table td[aria-colindex="3"] {
    width: 15%;
  }
  .import-participantes-list .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .import-participantes-list .registro table td[aria-colindex="5"] {
    width: 30px;
  }
</style>
